import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    number: '01',
    title: 'BONO 1 — Kit de Arranque Rápido',
    description: 'Empezá a vender en 7 días, no en 7 meses. Tu hoja de ruta para la primera semana: qué comprar primero, qué receta hacer primero, cómo sacar la primera foto y cómo conseguir el primer cliente. Sin vueltas.',
    value: '$6.000'
  }, {
    number: '02',
    title: 'BONO 2 — Calendario Express de Contenido',
    description: 'Nunca más te quedés sin saber qué postear. 30 días de ideas de contenido para Instagram y WhatsApp, adaptadas al mundo de las minidonas. Posts, historias, promociones y fechas especiales ya planificadas.',
    value: '$8.000'
  }, {
    number: '03',
    title: 'BONO 3 — Banco de Nombres y Frases para Vender',
    description: 'Las palabras exactas que hacen que la gente compre. +50 nombres creativos para tu emprendimiento, frases para tus historias de Instagram, textos para tu catálogo de WhatsApp y respuestas para las preguntas más comunes de tus clientes.',
    value: '$7.000'
  }];
  return <section className="w-full bg-white py-8 md:py-16" data-id="element-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-14">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-6 md:mb-12" data-id="element-15">
            🎁 3 BONOS ESTRATÉGICOS — SIEMPRE INCLUIDOS
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-6 md:mb-10" data-id="element-16">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="bg-orange-50 border border-orange-200 rounded-lg p-6" data-id="element-17">
                <div className="flex items-start gap-3 mb-4" data-id="element-18">
                  <GiftIcon className="w-6 h-6 text-orange-500 flex-shrink-0" data-id="element-19" />
                  <span className="text-sm font-bold text-orange-500" data-id="element-20">
                    #{bonus.number}
                  </span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-21">
                  {bonus.title}
                </h3>
                <p className="text-gray-600 text-sm mb-4 leading-relaxed" data-id="element-22">
                  {bonus.description}
                </p>
                <div className="flex items-center gap-2" data-id="element-23">
                  <span className="text-gray-400 line-through" data-id="element-24">
                    {bonus.value}
                  </span>
                  <span className="text-orange-500 font-bold" data-id="element-25">GRATIS</span>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-center" data-id="element-26">
            <p className="text-xl md:text-2xl font-bold text-gray-900" data-id="element-27">
              Valor total de los bonos:{' '}
              <span className="line-through text-gray-400" data-id="element-28">$21.000</span>
              {' → '}
              <span className="text-orange-500" data-id="element-29">GRATIS con tu Mega Pack</span>
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}